module.exports = __webpack_public_path__ + "static/image-banner-home-v2-4925003027efe8b1ac7126c4795710cb.png";